//  +----------------------------------------------------------------------
//  | 球友会 [ 关于台球，就用球友汇 ]
//  +----------------------------------------------------------------------
//  | Copyright (c) 2025 https://www.qyxtyfz.com All rights reserved.
//  +----------------------------------------------------------------------
//移动端商城API
let domain = 'https://api.qyhtyfz.com'
let h5Url = 'https://h5.qyhtyfz.com'
let opApiUrl = 'https://api.op.qyhtyfz.com'
let castViewerUrl = 'https://cast.qyhtyfz.com'
if (process.env.NODE_ENV === 'development') {
	domain = 'https://api.t.qyhtyfz.com'
	h5Url = 'http://localhost:8081'
	opApiUrl = 'https://op-api.t.qyhtyfz.com'
	castViewerUrl = 'https://cast.t.qyhtyfz.com'
}


// 请求域名 格式： https://您的域名
// #ifdef MP || APP-PLUS || APP-HARMONY
// HTTP_REQUEST_URL:'',
export const HTTP_REQUEST_URL = domain;
// #endif
// H5商城地址
export const HTTP_H5_URL = h5Url;
// #ifdef H5
export const HTTP_REQUEST_URL = domain;
// #endif
export const HEADER = {
	'content-type': 'application/json'
}; // 请求头配置
export const HEADERPARAMS = {
	'content-type': 'application/x-www-form-urlencoded'
}; // 请求头参数配置
export const TOKENNAME = 'Authori-zation'; // 回话密钥名称 请勿修改此配置
export const OP_API_URL = opApiUrl;
export const CAST_VIEWER_URL = castViewerUrl;
export const EXPIRE = 0; // 缓存时间 0 永久
export const LIMIT = 10; // 分页最多显示条数